import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

import { useRef, useState } from "react";

import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Button } from "@mui/material";

import { FLIGHT_DATA_FAST_FORWARD } from "@/constants/eventName";
import { dispatchEvent } from "@/hooks/useEventEmitter";
import usePlatform from "@/hooks/usePlatform";
import { useQuery } from "@/hooks/useQuery";

dayjs.extend(isSameOrBefore);

const DateFastForward = (props: { disabled: boolean }) => {
  const { disabled = false } = props;
  const { isMobile } = usePlatform();
  const queryInit = useQuery<{ oneWayRangeStartDate: number; oneWayRangeEndDate: number }>();
  const queryInitRef = useRef(queryInit);

  const [query, setQuery] = useState<{ startDate: number; endDate: number }>({
    startDate: queryInitRef.current.oneWayRangeStartDate * 1000,
    endDate: queryInitRef.current.oneWayRangeEndDate * 1000,
  });

  const rangeDate = dayjs(query.endDate).diff(query.startDate, "days");

  const handlePrev = () => {
    if (disabled) {
      return;
    }
    console.log(dayjs(query.startDate).format("YYYY-MM-DD"));
    const s1 = dayjs(query.startDate).subtract(1 + rangeDate, "days");
    const s2 = dayjs(query.startDate).subtract(1, "days");

    dispatchEvent(FLIGHT_DATA_FAST_FORWARD, [s1, s2]);

    setQuery({ startDate: s1.valueOf(), endDate: s2.valueOf() });
  };

  const handleNext = () => {
    if (disabled) {
      return;
    }
    console.log(dayjs(query.endDate).format("YYYY-MM-DD"));

    const s1 = dayjs(query.endDate).add(1, "day");
    const s2 = dayjs(query.endDate).add(1 + rangeDate, "day");

    console.log(dayjs(s1).format("YYYY-MM-DD"));
    console.log(dayjs(s2).format("YYYY-MM-DD"));

    dispatchEvent(FLIGHT_DATA_FAST_FORWARD, [s1, s2]);

    setQuery({ startDate: s1.valueOf(), endDate: s2.valueOf() });
  };

  return (
    <div className={"flex items-center space-x-[6px] " + (isMobile ? "mt-0" : "mr-[8px]")}>
      <Button
        variant={isMobile ? "outlined" : "contained"}
        sx={{ borderRadius: 20, fontWeight: 'bold' }}
        size="small"
        disabled={dayjs(query.startDate).isSameOrBefore(dayjs(), "D")}
        onClick={handlePrev}
        disableElevation
      >
        <KeyboardDoubleArrowLeftIcon /> {rangeDate + 1}{" "}
        {isMobile ? (rangeDate > 0 ? "days" : "day") : rangeDate > 0 ? "days" : "day"}
      </Button>
      <Button
        variant={isMobile ? "outlined" : "contained"}
        sx={{ borderRadius: 20, fontWeight: 'bold' }}
        size="small"
        onClick={() => handleNext()}
        disableElevation
      >
        {rangeDate + 1}{" "}
        {isMobile ? (rangeDate > 0 ? "days" : "day") : rangeDate > 0 ? "days" : "day"}
        <KeyboardDoubleArrowRightIcon />
      </Button>
    </div>
  );
};

export default DateFastForward;
